/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ApiErrorsService from 'cio/services/api-errors';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { isNone, isEmpty } from '@ember/utils';
import ignorePromiseFailure from 'cio/utils/ignore-promise-failure';
import IdentityModel from 'cio/models/identity';
import { Task } from 'ember-concurrency';
import EnvironmentService from 'cio/services/environment';
import DS from 'ember-data';
import AuthService from 'cio/services/auth';
import FormValidations from 'cio/utils/form-validations';

interface TwilioIdentitiesEditArgs {
  saveIdentityTask: Task<unknown, any[]>;
  identity: IdentityModel;
  saveButtonText: string;
  toggleEditing: () => unknown;
}

const Validations = {
  phone(value: string) {
    if (isNone(value) || isEmpty(value.trim())) {
      return "Alphanumeric ID can't be blank";
    }

    return true;
  },

  name(value: string) {
    if (!isEmpty(value) && isEmpty(value.trim())) {
      return 'Name cannot be all spaces';
    }

    return true;
  },
};

export default class TwilioIdentitiesEdit extends Component<TwilioIdentitiesEditArgs> {
  @service environment!: EnvironmentService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;
  @service auth!: AuthService;

  readonly validations = FormValidations.create({
    validations: Validations,
    context: this,
    modelKey: 'args.identity',
  });

  get saveButtonText(): string {
    return this.args.saveButtonText ?? 'Save Changes';
  }

  @action
  async saveIdentity() {
    return await this.validations.validateModel().then(async () => {
      return await this.args.saveIdentityTask.perform();
    }, ignorePromiseFailure);
  }

  @action
  onChange(field: 'phone' | 'email', value: string) {
    this.args.identity.set(field, value);
  }
}
